import axios from "axios";

export default axios.create({
  baseURL: "https://qakdci.seekinterns.com/",
  headers: {
    "Content-Type": "application/json",
  },
});



